import * as THREE from 'three'
import store from '../store'

import Experience from './Experience'

export default class Renderer {
  constructor() {
    this.experience = new Experience()
    this.canvas = this.experience.canvas
    this.scene = this.experience.scene
    this.camera = this.experience.camera

    this.setInstance()
  }

  setInstance() {
    this.instance = new THREE.WebGL1Renderer({
      canvas: this.canvas,
      antialias: true,
      alpha: true,
    })

    this.resize()
    this.instance.setClearColor('#000000', 0)
  }

  resize() {
    this.instance.setSize(store.bounds.ww, store.bounds.wh)
    
    // this.instance.setPixelRatio(Math.max(window.devicePixelRatio, 1.5))
  }

  update() {
    this.instance.render(this.scene, this.camera.instance)
  }
}